import React from "react"
import { PortableTextReactComponents } from "@portabletext/react"
import { useGeolocation } from "../../app-core/_common/providers/geolocation-provider"
import { websiteUrl } from "../../app-core/_common/localizeWebsiteUrl"

const InlineLocalizedPhoneNumber = () => {
    const geoLocation = useGeolocation()
    return <span>{geoLocation?.phone}</span>
}

export const customBlockContentComponents: Partial<PortableTextReactComponents> = {
    marks: {
        localizedPhoneNumber: () => <InlineLocalizedPhoneNumber />,
        linkToPage: (props) => {
            const path = props.value?.path
            return (
                <React.Fragment>
                    {path ? (
                        <a href={websiteUrl(path)}>{props.children}</a>
                    ) : (
                        <React.Fragment>{props.children}</React.Fragment>
                    )}
                </React.Fragment>
            )
        },
        // locationSpecificTextSection: ({ children, value }) => (
        //     <LocationSpecificTextSection value={value}>{children}</LocationSpecificTextSection>
        // ),
        // linkToFile: ({ value, children }) => {
        //     const fileAsset = getFileAsset(value.file.asset, sanityLocation)
        //     const fileURL = buildFileUrl(fileAsset, sanityLocation)
        //     if (value.forceDownload)
        //         return (
        //             <a href={`${fileURL}?dl=`} download>
        //                 {children}
        //             </a>
        //         )
        //     else return <a href={fileURL}>{children}</a>
        // },
    },
}
